import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CategoriesContext = createContext({ categories: [], categoryNames: [], refresh: async () => {} });

export function CategoriesProvider({ children }) {
    const { user } = useAuth();
    const [categories, setCategories] = useState([]);

    const refresh = useCallback(async () => {
        if (!user) { setCategories([]); return; }
        try {
            const { data } = await api.get("/categories");
            setCategories(data);
        } catch {}
    }, [user]);

    useEffect(() => { refresh(); }, [refresh]);

    const categoryNames = categories.map(c => c.name);

    return (
        <CategoriesContext.Provider value={{ categories, categoryNames, refresh }}>
            {children}
        </CategoriesContext.Provider>
    );
}

export const useCategories = () => useContext(CategoriesContext);
